import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../services/common-data.service';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-menu-current-user',
  templateUrl: './menu-current-user.component.html',
  styleUrls: ['./menu-current-user.component.css']
})
export class MenuCurrentUserComponent implements OnInit {

  firstname:any;
  lastname:any;
  date_joined:any;

  localModelDataStorage = false;
  modelName = 'User';
  modelData: any;
  avatar:any;
  points = 0;
  loggedIn;


  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService
  ) { 

    this.loggedIn = this.authService.isUserLoggedIn();

    if(this.loggedIn) {
    //lets get the model for this page
        this._data.getProfile() 
        .pipe(first())
        .subscribe(
          data => {
            this.modelData = data['cover']['model']['modelData']['formFieldsEntities'];

            this.firstname = data['cover']['model']['modelData']['formFieldsEntities']['first_name'];
            this.lastname = data['cover']['model']['modelData']['formFieldsEntities']['last_name'];
            //this.date_joined = data['cover']['model']['modelData']['formFieldsEntities']['date_joined'];
            this.avatar = data['cover']['model']['modelData']['formFieldsEntities']['avatar'][0]['tmp_name'];

            if(data['cover']['model']['modelData']['formFieldsEntities']['points'])
              this.points = data['cover']['model']['modelData']['formFieldsEntities']['points'];
          },
          error => {},
          () => {}
        );
    }
  }

  ngOnInit() {
  }

}
